
//标准菜单(admin)
const menuStandard =[

	{
		key:'client',	title:'客户管理', Icon:'user',
		Item:[{key:'/client/clientLegalPerson',url:'/client/clientLegalPerson',title:'法人列表', Icon:'user-add'},
			{key:'/client/recommend',url:'/client/recommend',title:'推客-企信宝', Icon:'user-add'},
			{key:'/client/recommend-self',url:'/client/recommend-self',title:'推客-大经宝', Icon:'usergroup-add'},
		{key:'/client/list',url:'/client/list',title:'客户汇总', Icon:'wechat'},
			{key:'/client/credit',url:'/client/credit',title:'客户授信记录', Icon:'solution'	}]

	},
	{
		key:'client2',	title:'采购宝客户管理', Icon:'user',
		Item:[
			{key:'/derClient/recommend',url:'/derClient/recommend',title:'采购宝推荐', Icon:'copyright'},
			{key:'/derClient/list',url:'/derClient/list',title:'采购宝客户汇总', Icon:'team'},],

	},
	{
		key:'loan',	title:'企信/大经宝订单', Icon:'transaction',
		Item:[
			{key:'/order/pending',url:'/order/pending',title:'待放款',Icon:"clock-circle" },
			{key:'/order/list',url:'/order/list',title:'订单明细',Icon:"check-square" },
			{key:'/order/controlProduct',url:'/order/controlProduct',title:'控货企信宝',Icon:"check-square" },
			{key:'/order/reportForClientQuota',url:'/order/reportForClientQuota',title:'客户可用额度',Icon:"read" },
			// {key:'/order/reportForBrief',url:'/order/reportForBrief',title:'企信宝日报',Icon:"container" },
			// {key:'/order/repayFail',url:'/order/repayFail',title:'异常还款',Icon:"exception" },

		]
		//Item:[{key:'/user/list',url:'/user/list',title:'标准会员', Icon:'user'	}]
	},
	{
		key:'derLoan',	title:'采购宝订单', Icon:'alipay-circle',
		Item:[
			{key:'/derOrder/pending',url:'/derOrder/pending',title:'待放款',Icon:"android" },
			{key:'/derOrder/list',url:'/derOrder/list',title:'订单明细',Icon:"apple" },
			{key:'/derOrder/reportForClientQuota',url:'/derOrder/reportForClientQuota',title:'采购客户可用额度',Icon:"read" },
			{key:'/derOrder/warehouseOut',url:'/derOrder/warehouseOut',title:'出库申请',Icon:"shopping-cart" },

		]
		//Item:[{key:'/user/list',url:'/user/list',title:'标准会员', Icon:'user'	}]
	},
	{
		key:'derLoanAfter',	title:'出入库单据', Icon:'shopping-cart',
		Item:[
			{key:'/derLoanAfter/in',url:'/derLoanAfter/in',title:'入库确认节点',Icon:"arrow-right" },

			{key:'/derLoanAfter/out',url:'/derLoanAfter/out',title:'出库确认节点' ,Icon:"arrow-left" },


		]
		//Item:[{key:'/user/list',url:'/user/list',title:'标准会员', Icon:'user'	}]
	},
	{
		key:'purRecordLoan',	title:'工程备案', Icon:'file-protect',
		Item:[
		{key:'/purRecordOrder/pending',url:'/purRecordOrder/pending',title:'新增备案',Icon:"plus-square" },
		{key:'/purRecordOrder/list',url:'/purRecordOrder/list',title:'备案明细',Icon:"unordered-list" },
		{key:'/purRecordOrder/projectAmount',url:'/purRecordOrder/projectAmount',title:'项目金额',Icon:"exception" },
	]
		//Item:[{key:'/user/list',url:'/user/list',title:'标准会员', Icon:'user'	}]
	},
	{
		key:'purLoan',	title:'工程通订单', Icon:'project',
		Item:[{key:'/purOrder/pending',url:'/purOrder/pending',title:'待放款',Icon:"clock-circle" },{key:'/purOrder/list',url:'/purOrder/list',title:'订单明细',Icon:"check-square" },
			]
		//Item:[{key:'/user/list',url:'/user/list',title:'标准会员', Icon:'user'	}]
	},
	{
		key:'ice',	title:'关联系统', Icon:'appstore',
		Item:[{key:'/ice/enter',url:'/ice/enter',title:'冰鉴系统',Icon:"smile" },{key:'/fullScreen/enter',url:'/fullScreen/enter',title:'大屏系统',Icon:"smile" }]
		//Item:[{key:'/user/list',url:'/user/list',title:'标准会员', Icon:'user'	}]
	},{
		key:'monitor',	title:'报表/监控', Icon:'appstore',
		Item:[
			{key:'/monitor/historyOrder',url:'/monitor/historyOrder',title:'历史订单',Icon:"exclamation" },
			{key:'/monitor/exception',url:'/monitor/exception',title:'企信宝异常',Icon:"exclamation" },
			{key:'/monitor/engException',url:'/monitor/engException',title:'工程通异常',Icon:"exclamation" },
			{key:'/order/repayFail',url:'/order/repayFail',title:'异常还款',Icon:"exception" },
			{key:'/order/exceedThirty',url:'/order/exceedThirty',title:'超30天未还款',Icon:"exception" },
			{key:'/order/exceedSixty',url:'/order/exceedSixty',title:'超60天未还款',Icon:"exception" },
		]
		//Item:[{key:'/user/list',url:'/user/list',title:'标准会员', Icon:'user'	}]
	},{
		key:'setting',	title:'设置/配置', Icon:'setting',
		Item:[{key:'/user/list',url:'/user/list',title:'用户',Icon:'user'},{key:'/setting/roleAuth',url:'/setting/roleAuth',title:'角色配置',Icon:'ordered-list'},{key:'/setting/parameter',url:'/setting/parameter',title:'参数',Icon:'share-alt'},{key:'/setting/password',url:'/setting/password',title:'修改密码',Icon:"safety-certificate"}]
	},	{
		key:'test',	title:'测试/调试', Icon:'tool',
		Item:[{key:'/test/color',url:'/test/color',title:'颜色样本',Icon:'bg-colors'},{key:'/test/api',url:'/test/api',title:'api调试',Icon:"share-alt"},{key:'/test/antdcomp',url:'/test/antdcomp',title:'Antd组件',Icon:"share-alt"}]
	}
];

//标准按钮(admin)
//btnStandard  某个菜单必须选一个按钮，否则视为没有权限打开。至少要开放刷新按钮。
//放这里的目的是给权限配置看的。需要和页面中按钮ID对应。所有KEY需要唯一。如果不唯一会造成权限配置时无法配置
const btnStandard =[
	{key:'/client/clientLegalPerson',btn:[{key:'/client/clientLegalPerson/refresh',title:'刷新'}]},
	{key:'/client/recommend',btn:[{key:'/client/recommend/refresh',title:'刷新'},{key:'/client/recommend/btn001',title:'新客'},{key:'/client/recommend/btn002',title:'修改'}]},
	{key:'/derClient/recommend',btn:[{key:'/derClient/recommend/refresh',title:'刷新'},{key:'/derClient/recommend/btn001',title:'新客'},{key:'/derClient/recommend/btn002',title:'修改'}]},
	{key:'/client/pending',btn:[{key:'/client/pending/refresh',title:'刷新'},{key:'/client/pending/btn001',title:'审核'},{key:'/client/pending/btn002',title:'上传合同'}]},
	{key:'/client/list',btn:[{key:'/client/list/refresh',title:'刷新'},
	{key:'/client/list/btn001',title:'修改'},{key:'/client/list/btn002',title:'禁用'},{key:'/client/list/btn003',title:'反担保标记'},{key:'/client/list/download',title:'导出'}]},

	{key:'/derClient/list',btn:[{key:'/derClient/list/refresh',title:'刷新'},
			{key:'/derClient/list/btn001',title:'修改'},{key:'/derClient/list/updateUsableAmount',title:'限制可用额度'},{key:'/derClient/list/btn002',title:'禁用'}]},
	{key:'/order/pending',btn:[{key:'/order/pending/refresh',title:'刷新'},{key:'/order/pending/btn002',title:'审核订单'},{key:'/order/pending/btn001',title:'上传合同'}]},
	{key:'/derOrder/pending',btn:[{key:'/derOrder/pending/refresh',title:'刷新'},{key:'/derOrder/pending/btn002',title:'审核订单'},{key:'/derOrder/pending/btn001',title:'上传合同'}]},
	{key:'/derOrder/warehouseOut',btn:[{key:'/derOrder/warehouseOut/btn001',title:'还款试算'},{key:'/derOrder/warehouseOut/btn002',title:'出库申请'}]},
	{key:'/order/list',btn:[{key:'/order/list/refresh',title:'刷新'},{key:'/order/list/download',title:'导出'},{key:'/order/list/downloadAll',title:'导出全部'},{key:'/order/list/cancelOrder',title:'撤销订单'}]},
	{key:'/order/controlProduct',btn:[{key:'/order/controlProduct/refresh',title:'刷新'},{key:'/order/controlProduct/download',title:'导出'}]},
	{key: "/order/repayFail", btn: [{key: "/order/repayFail/download", title: "导出"}]},
	{key: "/order/exceedThirty", btn: [{key: "/order/exceedThirty/download", title: "导出"}]},
	{key: "/order/exceedSixty", btn: [{key: "/order/exceedSixty/download", title: "导出"}]},
	{key:'/purOrder/pending',btn:[{key:'/purorder/pending/refresh',title:'刷新'},{key:'/purorder/pending/btn003',title:'选择备案'},{key:'/purorder/pending/btn002',title:'审核订单'},{key:'/purorder/pending/btn001',title:'上传附件'}]},
	{key:'/purRecordOrder/pending',btn:[{key:'/purRecordOrder/pending/btn001',title:'新增'},{key:'/purRecordOrder/pending/btn002',title:'上传附件'},{key:'/purRecordOrder/pending/btn003',title:'审核备案'},{key:'/purRecordOrder/pending/btn004',title:'新增商品'}]},
	{key:'/purOrder/list',btn:[{key:'/purorder/list/btnSupply',title:'补件'},{key:'/purorder/list/download',title:'导出'},{key:'/purorder/list/btnCopyOrder',title:'复制合同'},{key:'/purorder/list/purLoanAfter/dataPush',title:'资料推送'}]},
	{key:'/derOrder/list',btn:[{key:'/derOrder/list/btnSupply',title:'补件'},{key:'/derOrder/list/download',title:'导出'},{key:'/derOrder/list/cancelOrder',title:'撤销订单'}]},

	{key: "/purOrder/purLoanAfter", btn: [{key:'/purorder/purLoanAfter/refresh',title:'刷新'},{key:'/purorder/purLoanAfter/dataPush',title:'资料推送'}]},
	{key: "/derLoanAfter/out", btn: [{key:'/derLoanAfter/out/refresh',title:'刷新'},{key:'/derLoanAfter/out/upload',title:'上传单据'},{key:'/derLoanAfter/out/dataPush',title:'资料推送'}]},
	{key: "/derLoanAfter/in", btn: [{key:'/derLoanAfter/in/refresh',title:'刷新'},{key:'/derLoanAfter/in/upload',title:'上传单据'},{key:'/derLoanAfter/in/dataPush',title:'资料推送'}]},
	{key: "/derOrder/derLoanAfter", btn: [{key:'/derorder/derLoanAfter/refresh',title:'刷新'},{key:'/derorder/derLoanAfter/dataPush',title:'资料推送'}]},

]


export  {menuStandard,btnStandard}

